<div class="hcontainer hcontainer-wide page-container">
  <ng-content select="[page-header]"></ng-content>
  <div class="page-content hcontainer hcontainer-extended">
    <ng-content select="[page-content]"></ng-content>
  </div>
  <ng-content select="[page-footer]"></ng-content>
</div>

<cs-footer></cs-footer>
